import React from 'react'
import { BlocksHtml } from '../../../../common/types/api/page'
import { WidgetTypes } from '../../../../common/types/api/report'
import wrapperDecorator from '../wrapperDecorator'
import TextEditor from './textEditor'
import styled from 'styled-components'
import GenericIconButton from '../../../../common/components/actions/genericIconButton'

interface Props extends BlocksHtml {
    openEditor: () => void
    editMode: boolean
    type?: WidgetTypes
    className?:string
}
export function Text({ className, template, type, openEditor, editMode }: Props): JSX.Element {
    const isNotGallery = type !== WidgetTypes.GALLERY
    return (
        <Container className={`${className ?? ''}`} editMode={editMode} showBorder={isNotGallery}>
            {isNotGallery && editMode && (
                <div className="htmlPreviewContainer__actionButtons">
                    <GenericIconButton
                        icon="far fa-edit"
                        onClick={() => {
                            openEditor()
                        }}
                    />
                </div>
            )}
            <div className="htmlPreviewContainer__content">
                <span dangerouslySetInnerHTML={{ __html: '<div>' + template + '</div>' }} />
            </div>
        </Container>
    )
}

const Container = styled.div<{editMode:boolean, showBorder:boolean}>`
    margin: 30px;
    height: 100%;
    overflow: hidden;
    word-wrap: break-word;
    .htmlPreviewContainer {
        &__actionButtons {
            position: absolute;
            right: 60px;
            transform: translateY(-50%);
            display: flex;
            justify-content: flex-end;
            gap: 4px;
            width: 40px;
        }
        &__content {
            min-height: 100px;
            padding: 8px;
            border-radius: 4px;
            overflow: hidden;
            word-wrap: break-word;
            ${({ theme, editMode, showBorder }) => {
                if (showBorder) return `border: 1px solid ${editMode ? theme['gray-100'] : theme['gray-400']};`
            }}
            ${({ theme, editMode = false, showBorder = true }) => {
                let result = ''
                if (editMode) result += `background: ${theme['gray-100']};`

                if (showBorder) result += `border: 1px solid ${editMode ? theme['gray-100'] : theme['gray-400']};`

                return result
            }}
        }
    }
`

export default wrapperDecorator({ type: WidgetTypes.HTML, minHeight: 200, Editor: TextEditor })(Text)
